import { Create } from "@mui/icons-material";
import { Button, IconButton, TextField } from "@mui/material";
import Header from "../layouts/Header";
import { instance } from '../utils/api';
import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const cl ="app-page-profile";
function ChangePassword(){
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const handleChangePassword = async () => {
        const formData = {
            currentPassword,
            newPassword,
            confirmPassword,
        };

        try {
            const response = await instance.post('agents/change-password', formData);
            console.log('Password change response:', response.data);
            toast.success(response.data.message);
            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');
        } catch (error) {
            console.error('Error changing password:', error);
            toast.error(error.response.data.error);
        }
    };

    return(
        <>
            <div className="profile-page">
                <Header/>
            </div>
            <div className={`${cl}`}>
                <div className={`${cl}__wrapper`}>
                    <div className={`${cl}__card`}>
                        <h2 style={{margin:0}}>Change Password</h2>
                        <div style={{marginTop:10}} className={`${cl}__info`}>
                            <ul className={`${cl}__infolist`}>
                                <li className={`${cl}__infolistitem`}>
                                    <TextField
                                        type="password"
                                        value={currentPassword}
                                        onChange={(e) => setCurrentPassword(e.target.value)}
                                        id="standard-basic"
                                        label="Old Password"
                                        variant="standard"
                                    />
                                </li>
                                <li className={`${cl}__infolistitem`}>
                                <TextField
                                        type="password"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        id="standard-basic"
                                        label="New Password"
                                        variant="standard"
                                    />
                                </li>
                                <li className={`${cl}__infolistitem`}>
                                <TextField
                                        type="password"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        id="standard-basic"
                                        label="Verify Password"
                                        variant="standard"
                                    />
                                </li>
                                <li className={`${cl}__infolistitem --button`}>
                                <Button onClick={handleChangePassword} variant="contained">
                                        Update Password
                                    </Button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer position="top-right" />
        </> 
    )
}
export default ChangePassword;
